(() => {
  const init = () => {
    if (typeof window.Splide !== "function") return;

    document.querySelectorAll(".product-recommendations-section .splide").forEach((el) => {
      if (el.__nostoSplideMounted || el.classList.contains("is-initialized")) return;

      const splide = new window.Splide(el, {
        type: 'loop',
        perPage: 1,
        autoWidth: true,
        padding: { left: 0, right: 0 },
        arrows: false,
        pagination: false,
        keyboard: true,
        drag: true,
        gap: 0,
        autoplay: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        speed: 1000,
        breakpoints: {
          700: {
            perPage: 1,
            padding: { left: 0, right: 0 },
          },
        },
      });

      splide.mount();
      el.__nostoSplideMounted = true;

      const refresh = () => { try { splide.refresh(); } catch (_) {} };
      setTimeout(refresh, 200);
      setTimeout(refresh, 800);
      el.querySelectorAll("img").forEach(img => {
        if (!img.complete) img.addEventListener("load", refresh, { once: true });
      });
    });
  };

  init();
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();